var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayer = function SvgPlayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M7.5 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667M2.5 17.5v-1.667A3.333 3.333 0 0 1 5.833 12.5h3.334a3.333 3.333 0 0 1 3.333 3.333V17.5M13.334 2.608a3.334 3.334 0 0 1 0 6.459M17.5 17.5v-1.667a3.33 3.33 0 0 0-2.5-3.208"
  })));
};
export default SvgPlayer;